import { Component, OnInit, Input, AfterViewInit, ElementRef } from '@angular/core';
import { Buyer } from '../../../../dto';
import { BaseComponent } from '../../../../core';
import { GaService, BuyerService } from '../../../../services';

@Component({
  selector: 'app-my-membership-status-navigation',
  templateUrl: './my-membership-status-navigation.component.html',
  styleUrls: ['./my-membership-status-navigation.component.scss'],
})
export class MyMembershipStatusNavigationComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() currentPage: string;
  buyer: Buyer;

  constructor(private buyerService: BuyerService) {
    super();
  }

  ngOnInit() {
    this.buyerService.getBuyer().subscribe((buyer) => {
      this.buyer = buyer;
    });
  }
  ngAfterViewInit() {}
}
